import message from '@/ajax/shop/message/send';
import client from '@/ajax/shop/client';
import article from '@/ajax/shop/article';
import review from '@/ajax/shop/review';
import reviewImage from '@/ajax/shop/review_form_data';
import comment from '@/ajax/shop/comment';
import product from '@/ajax/shop/product';
import password from '@/ajax/shop/password';

/**
 * @module ajaxAPI/shop
 *
 * @description
 * Ajax-обертки для работы с функиционалом магазина
 */

const shop = {
  message,
  client,
  article,
  review,
  reviewImage,
  comment,
  product,
  password
};

export default shop;
